import stripHtml from "string-strip-html";
import i18n from "../language.js";

var bigInt = require("big-integer");
var composedAvatars=[];

class Helper{
    constructor(){
        this.textField = document.createElement("textarea");
    }

    
    decodeHtml(html){
      
      this.textField.innerHTML = html;
      return this.textField.value;
    }
    stringHasOnlyWhitespace(str){
        if (!str.replace(/\s/g, '').length) {
            return true;
        }
        return false;
    }
    // trim a string to a number of chars but not break words.
    getExcerpt(string_value, read_more, max_chars=150){
        
        if(read_more===undefined){
            read_more="..."
        }
        if(string_value===undefined){
            string_value="";
            return "";
        }
        //var max_chars=150;
        //trim the string to the maximum length
        var strippedHtml=stripHtml(string_value);
        var trimmedString = strippedHtml.substr(0, max_chars);
        
        //re-trim if we are in the middle of a word
        //trimmedString = trimmedString.substr(0, Math.max(trimmedString.length-1, trimmedString.lastIndexOf(" ")))

        // check ifg there is anyythiung more to read
        if(trimmedString!=string_value){
           if(trimmedString!=""){
                trimmedString+=read_more;
           }
        }
        
        return trimmedString;
    }

    compareVersion(v1, v2) {
        if (typeof v1 !== 'string') return false;
        if (typeof v2 !== 'string') return false;
        v1 = v1.split('.');
        v2 = v2.split('.');
        const k = Math.min(v1.length, v2.length);
        for (let i = 0; i < k; ++ i) {
            v1[i] = parseInt(v1[i], 10);
            v2[i] = parseInt(v2[i], 10);
            if (v1[i] > v2[i]) return 1;
            if (v1[i] < v2[i]) return -1;        
        }
        return v1.length == v2.length ? 0: (v1.length < v2.length ? -1 : 1);
    }

    composeAvatarImage(name){

        // create avatar from name string
        var conv=name.replace(/\./g,'').replace(/\s+/g, " ");
        var wordsInName=conv.split(" ");
      
      var l1,l2,char1,char2;
      if(wordsInName.length>1){
        l1=wordsInName[0].charCodeAt(0) ? wordsInName[0].charCodeAt(0):0 ;
        l2=wordsInName[wordsInName.length-1].charCodeAt(0) ? wordsInName[wordsInName.length-1].charCodeAt(0):0 ;
        char1=wordsInName[0].charAt(0) ? name.charAt(0).toUpperCase() : ".";
        char2=wordsInName[wordsInName.length-1].charAt(0) ? wordsInName[wordsInName.length-1].charAt(0).toUpperCase() : ".";
      }else{
        /* creates an avatar from first two characters username */
        l1=wordsInName[0].charCodeAt(0) ? wordsInName[0].charCodeAt(0):0;
        l2=wordsInName[0].charCodeAt(1) ? wordsInName[0].charCodeAt(1):0;
        char1=wordsInName[0].charAt(0) ? name.charAt(0).toUpperCase() : ".";
        char2=wordsInName[0].charAt(1) ? wordsInName[0].charAt(1).toUpperCase() : ".";
      }

      // check if in cache...
      if(composedAvatars[char1+char2]){
          return composedAvatars[char1+char2];
      }
      
      // get first two letters of a name
      var cut=parseInt(15777215/26);
      var c = l1+l2;
      var c_m= (c*cut) % 15777215;
      var cstr=c_m.toString();
      
      var color=bigInt(cstr).toString(16);
      
      // create bg color
      var w=250;
      var h=250;
      var canvas = document.createElement("canvas");
      canvas.width=w;
      canvas.height=h;
      var ctx = canvas.getContext('2d');
      ctx.fillStyle = "#"+color;
      ctx.fillRect(0, 0, w, h);

      // gradient
      // Create gradient
      /*
      var grd = ctx.createRadialGradient(parseInt(w/2), parseInt(h/2), parseInt(w/2)-40, parseInt(w/2), parseInt(h/2), parseInt(w/2));
      grd.addColorStop(0, 'rgba(0,0,0,0)');
      grd.addColorStop(1, 'rgba(0,0,0,.05)');
      // Fill with gradient
      ctx.fillStyle = grd;
      ctx.fillRect(0, 0, w, h);
      */
      
      // create text
      ctx.font = parseInt(w/1.9)+"px Arial";
      ctx.fillStyle = "white";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.shadowOffsetX = 8;
      ctx.shadowOffsetY = 8;
      ctx.shadowBlur = 8;
      ctx.shadowColor="rgba(0,0,0,.25)"
      ctx.fillText(char1+char2, w/2, h/2);

      composedAvatars[char1+char2]=canvas.toDataURL();

      return canvas.toDataURL();
    }
    
    convertChatDate(dateString){

        
        var weekdays=['sunday','monday','tuesday','wednesday','thursday','friday','saturday'];


        if(!dateString){
            return "";
        }

        // making sure the date is in format "YYYY/MM/DD 12:00:00" especially with the  "/"  not the "-"
        dateString=dateString.replace(/-/g, '/');

        var d,options;

        // format date to cut of the seconds..
        d=new Date(dateString);
        
        options = { year:"numeric", month:"2-digit", day:"2-digit", hour: 'numeric', minute: '2-digit' };
        var date = d.toLocaleDateString([],options).replace(/\//g,"-");

        
        // format to time only
        d=new Date(dateString);
        options = { hour: 'numeric', minute: '2-digit' };
        var time= d.toLocaleTimeString([],options).replace(/\//g,"-");

        // find out how many days ago...
        var msInADay=86400000;

        // create dates with MDY only to see if date is how many days ago
        //options = { year:"numeric", month:"2-digit", day:"2-digit"};
        var messageDate=new Date(new Date(dateString).toDateString());
        var currentDate=new Date(new Date(Date.now()).toDateString());

        var ct = currentDate.getTime();
        var mt = messageDate.getTime();

        var daysAgo=parseInt((ct-mt)/msInADay);
       
        var composedDate;

        if(daysAgo<1){
            composedDate = i18n.t("language.today")+", "+time;
        }
        if(daysAgo==1){
            composedDate = i18n.t("language.yesterday")+", "+time;
        }
        if(daysAgo>1 && daysAgo<7){
            // get weekday as integer (0 = sunday)
            var weekDayInteger=new Date(dateString).getDay();
            composedDate = i18n.t("language."+weekdays[weekDayInteger])+", "+time;
        }
        if(daysAgo>=7){
            composedDate = date;
        }
        
        return composedDate;
    }


    sanatizeFilename(str){

        str = str.replace(/^\s+|\s+$/g, ''); // trim
        str = str.toLowerCase();
    
        // remove accents, swap ñ for n, etc
        var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
        var to   = "aaaaeeeeiiiioooouuuunc------";
        for (var i=0, l=from.length ; i<l ; i++) {
            str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
        }

        str = str.replace(/[^a-z0-9 -.]/g, '') // remove invalid chars
            .replace(/\s+/g, '_') // collapse whitespace and replace by -
            .replace(/-+/g, '_'); // collapse dashes

        return str;
    }

}

export let helper = new Helper();